import React, { Component, Fragment } from 'react'
import InputText, { InputTextProps } from './InputText'
import ModalScan from './ModalScan'

interface Props extends Omit<InputTextProps, 'icon' | 'onIconClick'> {
  onScan(name: string, value: string): void
}

interface State {
  modal: boolean
}

export default class InputScan extends Component<Props, State> {
  initialState: State = {
    modal: false
  }

  constructor (props: Props) {
    super(props)
    this.state = this.initialState
  }

  handleIconClick = () => {
    this.setState({ modal: true })
  }

  handleScan = (value: string) => {
    const { name, onScan, onChange } = this.props
    if (onChange) onChange(name, value)
    onScan(name, value)
  }

  handleModalClose = () => {
    this.setState({ modal: false })
  }

  render () {
    return (
      <Fragment>
        <InputText
          name={this.props.name}
          value={this.props.value}
          label={this.props.label}
          type={this.props.type}
          placeholder={this.props.placeholder}
          readonly={this.props.readonly}
          autofocus={this.props.autofocus}
          autoFocusCallback={this.props.autoFocusCallback}
          icon="camera"
          customRef={this.props.customRef}
          onChange={this.props.onChange}
          onFocus={this.props.onFocus}
          onBlur={this.props.onBlur}
          onScan={this.props.onScan}
          onIconClick={this.handleIconClick} />
          {
            this.state.modal && <ModalScan
            onScan={this.handleScan}
            onClose={this.handleModalClose} />
          }
      </Fragment>
    )
  }
}
